import {
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  useInfiniteQuery,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import { axiosCentral, throwResponse } from "config/axios";
import { INotificationDetails, INotificationParams } from "./inteface";
import { IResponseNotification } from "config/axios/interface";

export const useGetNotifications = (
  params?: INotificationParams
): UseQueryResult<IResponseNotification<INotificationDetails[]>, Error> => {
  return useQuery(
    ["get-notification", params],
    async () => {
      const res = await axiosCentral.get(
        "/administrator/notification-admin-bells"
      );
      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useScrollGetNotifications = (
  params?: INotificationParams
): UseInfiniteQueryResult<
  IResponseNotification<INotificationDetails[]>,
  Error
> => {
  return useInfiniteQuery(
    ["get-notification", "scroll", params],
    async ({ pageParam }) => {
      const res = await axiosCentral.get(
        "/administrator/notification-admin-bells",
        {
          params: { ...params, ...pageParam },
        }
      );

      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    { keepPreviousData: true, enabled: params?.enabled }
  );
};

export const useGetNotificationsSidebar = (
  params?: INotificationParams
): UseQueryResult<INotificationDetails[]> => {
  return useQuery(
    ["get-notification-sidebar", params],
    async () => {
      const res = await axiosCentral.get(`/administrator/notification`, {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const usePatchNotificationsSidebarById = (): UseMutationResult => {
  return useMutation(async ({ ...data }: any) => {
    const res = await axiosCentral.patch(`/administrator/notification`, data);
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};

export const usePatchNotificationsSidebarBySlug = (): UseMutationResult => {
  return useMutation(async ({ ...data }: any) => {
    const res = await axiosCentral.patch(
      `/administrator/notification/category`,
      data
    );
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};

export const usePatchNotificationsAdminBells = (): UseMutationResult => {
  return useMutation(async ({ ...data }: any) => {
    const res = await axiosCentral.patch(
      `/administrator/notification-admin-bells`,
      data
    );
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};
